import { render, staticRenderFns } from "./Student.vue?vue&type=template&id=73041c92&"
import script from "./Student.vue?vue&type=script&lang=ts&"
export * from "./Student.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports